module.exports = "/images/delivered.svg";